import { Injectable, inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';

@Injectable({
  providedIn: 'root'
})
export class SplashScreenService {
  private document = inject(DOCUMENT);

  dismiss() {
    const loader = this.document.getElementById('globalSplashLoader');
    if (loader) {
      loader.style.opacity = '0';
      loader.style.pointerEvents = 'none'; // let clicks through while it fades
      
      setTimeout(() => {
        loader.remove();
      }, 300);
    }
  }
}